<div [ngClass]="size">
    <mat-icon fontSet="material-icons-outlined" class="d-flex">{{ icon }}</mat-icon>
</div>
